<template>
  <div v-if="screenWidth >= 992" class="header-top">
    <div class="header-top__block">
      <MenuHiding>
        <a v-for="item in serviceMenu.slice(1)" :href="item.href" class="header-top-menu__link">
          {{ item.name }}
        </a>
      </MenuHiding>
      <div class="header-top__elements">
        <CurrencySwitcher />
        <DeliveryCountry />
        <DefLangSelect />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import DefLangSelect from '@components/Def/DefLang/DefLangSelect.vue';
import DeliveryCountry from '@components/Header/DeliveryCountry/DeliveryCountry.vue';
import MenuHiding from '@components/Menu/MenuHiding/MenuHiding.vue';
import useScreenWidth from '@use/useScreenWidth';
import CurrencySwitcher from '@components/Header/Currency/CurrencySwitcher.vue';
import { computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const screenWidth = useScreenWidth();
const resultsStore = useResultsStore();

const serviceMenu = computed(() => resultsStore.menus.serviceMenu.items);
</script>

<style lang="scss" scoped>
.header-top {
  background-color: var(--background-black);
  &__block {
    display: flex;
    justify-content: space-between;
    height: 40px;
    color: #ffffff;
    @extend %container;
  }
  &__elements {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
}
.header-top-menu {
  &__link {
    display: inline-flex;
    align-items: center;
    transition: 0.2s linear color;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%; /* 17.5px */
    color: #ffffff;
    &:hover {
      color: var(--color-link-hover);
    }
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
}
</style>
